export const ORDERS_PAGE_SIZE_OPTIONS = [5, 10, 15, 20, 25, 30];

/** Page numbers for legacy Previous / Next pagination (up to 5 visible). */
export function getTablePageNumbers(currentPage, totalPages, maxPagesToShow = 5) {
    const pages = [];
    if (totalPages <= maxPagesToShow) {
        for (let i = 1; i <= totalPages; i += 1) pages.push(i);
    } else {
        let startPage = Math.max(1, currentPage - 2);
        let endPage = Math.min(totalPages, startPage + maxPagesToShow - 1);
        if (endPage - startPage < maxPagesToShow - 1) {
            startPage = Math.max(1, endPage - maxPagesToShow + 1);
        }
        for (let i = startPage; i <= endPage; i += 1) pages.push(i);
    }
    return pages;
}

function getPageNumbers(currentPage, totalPages) {
    const pages = [];
    const maxPagesToShow = 5;

    if (totalPages <= maxPagesToShow) {
        for (let i = 1; i <= totalPages; i++) {
            pages.push(i);
        }
    } else {
        let startPage = Math.max(1, currentPage - 2);
        let endPage = Math.min(totalPages, startPage + maxPagesToShow - 1);

        if (endPage - startPage < maxPagesToShow - 1) {
            startPage = Math.max(1, endPage - maxPagesToShow + 1);
        }

        for (let i = startPage; i <= endPage; i++) {
            pages.push(i);
        }
    }

    return pages;
}

/** Compact pagination items: page numbers with ellipsis when needed. */
export function getPageNumbersWithEllipsis(currentPage, totalPages) {
    if (totalPages <= 5) {
        return getPageNumbers(currentPage, totalPages).map((n) => ({ type: 'page', value: n }));
    }
    const set = new Set([1, totalPages, currentPage, currentPage - 1, currentPage + 1]);
    const sorted = [...set].filter((n) => n >= 1 && n <= totalPages).sort((a, b) => a - b);
    const result = [];
    for (let i = 0; i < sorted.length; i++) {
        if (i > 0 && sorted[i] - sorted[i - 1] > 1) result.push({ type: 'ellipsis' });
        result.push({ type: 'page', value: sorted[i] });
    }
    return result;
}
